export function executeDownloadAttachment(
  downloadUrl: string,
  fileName: string | null = null,
): void {
  // 透過動態建立 <a> 標籤來下載
  const link = document.createElement('a');
  link.href = downloadUrl;
  if (fileName) {
    link.download = fileName; // 不設定時，會使用伺服器回傳的檔名
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
